import React from "react";
export const ComingSoon: React.FC = () => {
  return (
    <div className="bg-slate-900 bg-blend-multiply">
      <div className="h-[550px] md:h-[600] flex justify-center items-center">
        <h1 className="text-3xl text-white font-bold">
          Content Coming soon...
        </h1>
      </div>
    </div>
  );
};
